enum COLOR {
  PURPLE = "#884EA6",
  GREEN = "#66C790",
  BLUE = "#6164C2",
}

export default COLOR;
